import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
import { costs, faqs } from '../data/copy';
import { purchases } from '../data/testimonials';
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-21" data-mp="3pjha3tlwv2aj">
        <div className="mx-auto max-w-3xl text-center" data-id="element-22" data-mp="3bt443wskxxnu">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-light" aria-hidden="true" data-id="element-23" data-mp="3brj8e3uj48oe" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-24" data-mp="3gkm0s8nklc30">GARANTÍA 7 DÍAS — PAZ MENTAL TOTAL</h2>
          <div className="mt-8 rounded-2xl border-2 border-brand-green/40 p-7 sm:p-10" data-id="element-25" data-mp="31wrat00y5ltm">
            <p className="text-lg leading-relaxed text-slate-300 sm:text-xl" style={{
            fontSize: "15px"
          }} data-id="element-26" data-mp="36uizzma7itu4">
              Si en 7 días no sentís el alivio y la seguridad de tener toda la documentación bajo control, te devolvemos el 100% de tu dinero.
            </p>
            <p className="mt-4 font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-27" data-mp="2fqid4b4jqgoc">Sin preguntas.</p>
          </div>
          <p className="mt-5 text-sm text-slate-400" data-id="element-28" data-mp="2asgs3knk87a8">Tasa de devoluciones: menos del 1%.</p>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-29" data-mp="2kqwoa21g26ql">
        <div className="mx-auto max-w-3xl" data-id="element-30" data-mp="2krfsyh232ymo">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-31" data-mp="1x12c7moy8m7e">PREGUNTAS FRECUENTES</h2>
          <div className="mt-10 space-y-3" data-id="element-32" data-mp="1s2h7pb2nzgd5">
            {faqs.map(([question, answer], index) => {
            const panelId = `faq-panel-${index}`;
            const isOpen = open === index;
            return <div key={question} className="overflow-hidden rounded-xl border border-white/10 bg-brand-dark" data-id="element-33" data-mp="220olxm5kjkbg" data-mpi={index}>
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold sm:text-lg" data-id="element-34" data-mp="1ea11k1egv280">
                    <span data-id="element-35" data-mp="1yzdew2mrqe0x">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-light transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-36" data-mp="231gpyq5izglo" />
                  </button>
                  <div id={panelId} className="accordion-panel" data-open={isOpen} aria-hidden={!isOpen} data-id="element-37" data-mp="2cr0by4ojbqkr">
                    <div data-id="element-38" data-mp="1g1iy32feey7z">
                      <p className="border-t border-white/10 px-5 py-5 leading-relaxed text-slate-300" data-id="element-39" data-mp="1g2c8qehha7ve">{answer}</p>
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-40" data-mp="1u123vokqlxh4">
      <div className="mx-auto max-w-4xl" data-id="element-41" data-mp="1tyfq37796lqg">
        <h2 className="text-center font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-42" data-mp="30ft19ianj06e">⚖️ ¿CUÁNTO CUESTA SEGUIR SIN ORDEN?</h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-[#1a4a2e]" data-id="element-43" data-mp="35e4du0sbzosb">
          {costs.map(([title, detail]) => <div key={title} className="flex gap-3 border-b border-l-4 border-[#1a4a2e] border-l-[#2d6b45] bg-[#0d2f1e] px-5 py-4 last:border-b-0" data-id="element-44" data-mp="tug8pndw9uzt">
              <span className="text-red-400" aria-hidden="true" data-id="element-45" data-mp="k1r1j4pdn3aa">×</span>
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-46" data-mp="f490e0hlpscu"><b className="text-white" data-id="element-47" data-mp="f1mt81ymhev5">{title}:</b> {detail}</p>
            </div>)}
        </div>
        
        
        
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const reveal = window.setTimeout(() => setVisible(true), 12000);
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
    }, 40000);
    return () => {
      window.clearTimeout(reveal);
      window.clearInterval(timer);
    };
  }, []);
  useEffect(() => {
    if (!visible) return;
    const dismiss = window.setTimeout(() => setVisible(false), 5000);
    return () => window.clearTimeout(dismiss);
  }, [visible, purchase]);
  return <>
      <footer className="border-t border-white/10 bg-brand-ink px-4 py-12 text-center" data-id="element-48" data-mp="1olmr82o99dzf">
        <span className="inline-block rounded-full border border-brand-green/25 bg-brand-green/10 px-3 py-1 text-sm font-semibold text-brand-light" data-id="element-49" data-mp="1tkh992eeeyih">🎯 PACK HISTORIA MÉDICA EN ORDEN™</span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-slate-300" data-id="element-50" data-mp="1fr8278dxap34">El sistema de organización documental para madres argentinas con hijos con epilepsia refractaria.</p>
        <p className="mx-auto mt-2 max-w-md text-sm font-[800] italic text-slate-500" data-id="element-51" data-mp="15wpy424lgris">“Tu historia médica no tiene que ser un caos.”</p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-52" data-mp="wu70bwfo153e">
          <a className="transition-colors duration-150 ease-out hover:text-brand-light" href="mailto:soportebiomalivido@gmail.com" data-id="element-53" data-mp="10vk480z76y7o">📧 soportebiomalivido@gmail.com</a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-light" href="https://www.instagram.com/biomalivido/" target="_blank" rel="noreferrer" data-id="element-54" data-mp="i7rqti6gkz2p">📲 @biomalivido</a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-light" href="https://www.biomalivido.com" target="_blank" rel="noreferrer" data-id="element-55" data-mp="r9r7uahh435n">🌐 biomalivido.com</a>
        </div>
        <p className="mx-auto mt-8 max-w-xl text-xs text-slate-600" data-id="element-56" data-mp="1152ncv0pheeg">© PACK HISTORIA MÉDICA EN ORDEN™ 2026 — Todos los derechos reservados.</p>
      </footer>

      {visible && <aside className="proof-popup fixed bottom-5 left-5 z-50 max-w-[285px] rounded-xl border border-brand-green/30 bg-brand-ink p-4 shadow-2xl" aria-live="polite" data-id="element-57" data-mp="19z7ab3cpy5op">
          <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand-light" data-id="element-58" data-mp="15zgf8ng5t3ed"><CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-59" data-mp="1juipfms1hewz" />Acceso confirmado</p>
          <p className="mt-2 text-sm font-semibold" data-id="element-60" data-mp="1evo1k6f7t060">{purchases[purchase][0]} de {purchases[purchase][1]}</p>
          <p className="text-sm text-slate-300" data-id="element-61" data-mp="cijdr3gkouxo">adquirió el Pack Historia Médica en Orden™</p>
          <p className="mt-1 text-xs text-slate-500" data-id="element-62" data-mp="gjle5nm87d18">hace unos minutos</p>
        </aside>}
    </>;
}